// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Component/SideData/Overview/AiAgentWorkFlow/ValidationRulesBuilder.module.css */

.ValidationRulesBuilder_container__hIKT\\+ {
  margin-top: 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ValidationRulesBuilder_header__SX9qn {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.ValidationRulesBuilder_headerLeft__lpKxq {
  flex: 1 1;
  min-width: 0;
}

.ValidationRulesBuilder_title__eJrMQ {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
}

.ValidationRulesBuilder_subtitle__zrWLG {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.ValidationRulesBuilder_addBtn__Apm7p {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: #4a7feb;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.ValidationRulesBuilder_addBtn__Apm7p:hover:not(:disabled) {
  background: #3a6fd4;
}

.ValidationRulesBuilder_addBtn__Apm7p:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ValidationRulesBuilder_loadingHint__35OiG {
  font-size: 12px;
  color: #64748b;
  padding: 12px 0;
  text-align: center;
}

.ValidationRulesBuilder_empty__sTfwD {
  font-size: 12px;
  color: #94a3b8;
  padding: 16px 12px;
  text-align: center;
  background: white;
  border-radius: 6px;
  border: 1px dashed #cbd5e1;
}

.ValidationRulesBuilder_list__Vr5Ym {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ValidationRulesBuilder_ruleRow__5L2eL {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
}

.ValidationRulesBuilder_ruleBody__mkdO8 {
  flex: 1 1;
  min-width: 0;
}

.ValidationRulesBuilder_ruleSummary__Bj6Y1 {
  font-size: 13px;
  color: #2d3748;
  line-height: 1.4;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.ValidationRulesBuilder_ruleMessage__ag3t9 {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
  font-style: italic;
}

.ValidationRulesBuilder_ruleWarning__8JCu5 {
  margin-top: 6px;
  font-size: 11px;
  color: #b45309;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 4px;
  padding: 4px 8px;
  display: inline-block;
}

.ValidationRulesBuilder_ruleActions__jrPFd {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.ValidationRulesBuilder_iconBtn__OQG9J {
  padding: 5px 7px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ValidationRulesBuilder_iconBtn__OQG9J:hover {
  background: #f1f5f9;
  color: #334155;
}

.ValidationRulesBuilder_iconBtnDanger__BHFrI:hover {
  background: #fee2e2;
  color: #dc2626;
}

/* ---------- Modal ---------- */

.ValidationRulesBuilder_modalOverlay__bdL93 {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.ValidationRulesBuilder_modal__bFT7L {
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.ValidationRulesBuilder_modalHeader__W5ijU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8f0;
}

.ValidationRulesBuilder_modalTitle__C0ZIb {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a202c;
}

.ValidationRulesBuilder_modalClose__VnnUV {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ValidationRulesBuilder_modalClose__VnnUV:hover {
  color: #475569;
}

.ValidationRulesBuilder_modalBody__wYYYs {
  padding: 16px 18px;
  overflow-y: auto;
  flex: 1 1;
}

.ValidationRulesBuilder_modalActions__n1Oxp {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e2e8f0;
}

.ValidationRulesBuilder_cancelBtn__kZUxQ {
  padding: 7px 14px;
  background: transparent;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
}

.ValidationRulesBuilder_cancelBtn__kZUxQ:hover {
  background: #f8fafc;
}

.ValidationRulesBuilder_confirmBtn__2dd9R {
  padding: 7px 14px;
  background: #4a7feb;
  border: none;
  border-radius: 5px;
  font-size: 13px;
  color: white;
  font-weight: 500;
  cursor: pointer;
}

.ValidationRulesBuilder_confirmBtn__2dd9R:hover {
  background: #3a6fd4;
}

/* ---------- Form fields ---------- */

.ValidationRulesBuilder_field__MraYa {
  margin-bottom: 12px;
}

.ValidationRulesBuilder_fieldRow__QP8qo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.ValidationRulesBuilder_label__YHT1A {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 5px;
}

.ValidationRulesBuilder_input__MqHk-,
.ValidationRulesBuilder_select__JUo5u {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  font-size: 13px;
  color: #1a202c;
  box-sizing: border-box;
  background: white;
}

.ValidationRulesBuilder_input__MqHk-:focus,
.ValidationRulesBuilder_select__JUo5u:focus {
  outline: none;
  border-color: #4a7feb;
  box-shadow: 0 0 0 3px rgba(74, 127, 235, 0.15);
}

.ValidationRulesBuilder_kindPicker__E3maw {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ValidationRulesBuilder_kindCard__o0LHt {
  text-align: left;
  padding: 10px 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
}

.ValidationRulesBuilder_kindCard__o0LHt:disabled {
  cursor: default;
}

.ValidationRulesBuilder_kindCardActive__mR7t2 {
  border-color: #4a7feb;
  background: #eff6ff;
  box-shadow: 0 0 0 2px rgba(74, 127, 235, 0.15);
}

.ValidationRulesBuilder_kindCardTitle__dlWsj {
  font-size: 12px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 3px;
}

.ValidationRulesBuilder_kindCardDesc__45vok {
  font-size: 11px;
  color: #64748b;
  line-height: 1.4;
}

.ValidationRulesBuilder_multiPicker__jGWJn {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: white;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ValidationRulesBuilder_multiItem__jzvDr {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #334155;
}

.ValidationRulesBuilder_multiItem__jzvDr:hover {
  background: #f1f5f9;
}

.ValidationRulesBuilder_emptyHint__C8rKw {
  font-size: 12px;
  color: #94a3b8;
  font-style: italic;
  padding: 6px 0;
}

.ValidationRulesBuilder_errorText__2pyrj {
  margin-top: 6px;
  font-size: 12px;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 6px 10px;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ValidationRulesBuilder.module.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* src/Component/SideData/Overview/AiAgentWorkFlow/ValidationRulesBuilder.module.css */\n\n.container {\n  margin-top: 16px;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.headerLeft {\n  flex: 1;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.addBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  background: #4a7feb;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.addBtn:hover:not(:disabled) {\n  background: #3a6fd4;\n}\n\n.addBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.loadingHint {\n  font-size: 12px;\n  color: #64748b;\n  padding: 12px 0;\n  text-align: center;\n}\n\n.empty {\n  font-size: 12px;\n  color: #94a3b8;\n  padding: 16px 12px;\n  text-align: center;\n  background: white;\n  border-radius: 6px;\n  border: 1px dashed #cbd5e1;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ruleRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.ruleBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.ruleSummary {\n  font-size: 13px;\n  color: #2d3748;\n  line-height: 1.4;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.ruleMessage {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #64748b;\n  font-style: italic;\n}\n\n.ruleWarning {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #b45309;\n  background: #fef3c7;\n  border: 1px solid #fde68a;\n  border-radius: 4px;\n  padding: 4px 8px;\n  display: inline-block;\n}\n\n.ruleActions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.iconBtn {\n  padding: 5px 7px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  color: #64748b;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconBtn:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.iconBtnDanger:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* ---------- Modal ---------- */\n\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.modal {\n  background: white;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modalTitle {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.modalClose {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalClose:hover {\n  color: #475569;\n}\n\n.modalBody {\n  padding: 16px 18px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 18px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.cancelBtn {\n  padding: 7px 14px;\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  border-radius: 5px;\n  font-size: 13px;\n  color: #334155;\n  cursor: pointer;\n}\n\n.cancelBtn:hover {\n  background: #f8fafc;\n}\n\n.confirmBtn {\n  padding: 7px 14px;\n  background: #4a7feb;\n  border: none;\n  border-radius: 5px;\n  font-size: 13px;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.confirmBtn:hover {\n  background: #3a6fd4;\n}\n\n/* ---------- Form fields ---------- */\n\n.field {\n  margin-bottom: 12px;\n}\n\n.fieldRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  margin-bottom: 5px;\n}\n\n.input,\n.select {\n  width: 100%;\n  padding: 7px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 5px;\n  font-size: 13px;\n  color: #1a202c;\n  box-sizing: border-box;\n  background: white;\n}\n\n.input:focus,\n.select:focus {\n  outline: none;\n  border-color: #4a7feb;\n  box-shadow: 0 0 0 3px rgba(74, 127, 235, 0.15);\n}\n\n.kindPicker {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.kindCard {\n  text-align: left;\n  padding: 10px 12px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.kindCard:disabled {\n  cursor: default;\n}\n\n.kindCardActive {\n  border-color: #4a7feb;\n  background: #eff6ff;\n  box-shadow: 0 0 0 2px rgba(74, 127, 235, 0.15);\n}\n\n.kindCardTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 3px;\n}\n\n.kindCardDesc {\n  font-size: 11px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.multiPicker {\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 5px;\n  background: white;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.multiItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #334155;\n}\n\n.multiItem:hover {\n  background: #f1f5f9;\n}\n\n.emptyHint {\n  font-size: 12px;\n  color: #94a3b8;\n  font-style: italic;\n  padding: 6px 0;\n}\n\n.errorText {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #dc2626;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 4px;\n  padding: 6px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ValidationRulesBuilder_container__hIKT+`,
	"header": `ValidationRulesBuilder_header__SX9qn`,
	"headerLeft": `ValidationRulesBuilder_headerLeft__lpKxq`,
	"title": `ValidationRulesBuilder_title__eJrMQ`,
	"subtitle": `ValidationRulesBuilder_subtitle__zrWLG`,
	"addBtn": `ValidationRulesBuilder_addBtn__Apm7p`,
	"loadingHint": `ValidationRulesBuilder_loadingHint__35OiG`,
	"empty": `ValidationRulesBuilder_empty__sTfwD`,
	"list": `ValidationRulesBuilder_list__Vr5Ym`,
	"ruleRow": `ValidationRulesBuilder_ruleRow__5L2eL`,
	"ruleBody": `ValidationRulesBuilder_ruleBody__mkdO8`,
	"ruleSummary": `ValidationRulesBuilder_ruleSummary__Bj6Y1`,
	"ruleMessage": `ValidationRulesBuilder_ruleMessage__ag3t9`,
	"ruleWarning": `ValidationRulesBuilder_ruleWarning__8JCu5`,
	"ruleActions": `ValidationRulesBuilder_ruleActions__jrPFd`,
	"iconBtn": `ValidationRulesBuilder_iconBtn__OQG9J`,
	"iconBtnDanger": `ValidationRulesBuilder_iconBtnDanger__BHFrI`,
	"modalOverlay": `ValidationRulesBuilder_modalOverlay__bdL93`,
	"modal": `ValidationRulesBuilder_modal__bFT7L`,
	"modalHeader": `ValidationRulesBuilder_modalHeader__W5ijU`,
	"modalTitle": `ValidationRulesBuilder_modalTitle__C0ZIb`,
	"modalClose": `ValidationRulesBuilder_modalClose__VnnUV`,
	"modalBody": `ValidationRulesBuilder_modalBody__wYYYs`,
	"modalActions": `ValidationRulesBuilder_modalActions__n1Oxp`,
	"cancelBtn": `ValidationRulesBuilder_cancelBtn__kZUxQ`,
	"confirmBtn": `ValidationRulesBuilder_confirmBtn__2dd9R`,
	"field": `ValidationRulesBuilder_field__MraYa`,
	"fieldRow": `ValidationRulesBuilder_fieldRow__QP8qo`,
	"label": `ValidationRulesBuilder_label__YHT1A`,
	"input": `ValidationRulesBuilder_input__MqHk-`,
	"select": `ValidationRulesBuilder_select__JUo5u`,
	"kindPicker": `ValidationRulesBuilder_kindPicker__E3maw`,
	"kindCard": `ValidationRulesBuilder_kindCard__o0LHt`,
	"kindCardActive": `ValidationRulesBuilder_kindCardActive__mR7t2`,
	"kindCardTitle": `ValidationRulesBuilder_kindCardTitle__dlWsj`,
	"kindCardDesc": `ValidationRulesBuilder_kindCardDesc__45vok`,
	"multiPicker": `ValidationRulesBuilder_multiPicker__jGWJn`,
	"multiItem": `ValidationRulesBuilder_multiItem__jzvDr`,
	"emptyHint": `ValidationRulesBuilder_emptyHint__C8rKw`,
	"errorText": `ValidationRulesBuilder_errorText__2pyrj`
};
export default ___CSS_LOADER_EXPORT___;
